
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { OrganizationService } from './organization.service';
import OrganizationInterface from '@/interfaces/Organization.interface';
import { ToastFactory } from '@/utils/ToastFactory';
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import UserService from '../Users/user.service';
const orgService = new OrganizationService();
const userService = new UserService();

export default defineComponent({
  name: 'AddOrganization',
  data() {
    return {
        form:{
            organization: {
                isCompany: true,
                address:{} as any,
                contacts: [
                    {
                        id: '' as string,
                        name: '' as string,
                        email: '' as string,
                        phone: '' as string,
                        typeContact: 'administrator' as string,
                        isDirty: false,
                    },
                ] as any,
            } as OrganizationInterface,
        },

        saveProcessError: false,
        disabled: false,

        organizationId: "" as string,

        typeContact: [
            { name: 'Administrativo', code: 'administrator', title_key: 'org.fields.adm' },
            { name: 'Financeiro', code: 'financial', title_key: 'org.fields.finance' },
            { name: 'Técnico', code: 'technician', title_key: 'org.fields.tech' },
        ] as any,

        newContact: {
            id: '',
            name: '',
            email: '',
            phone: '',
            typeContact: '',
            isDirty: false
        },

        params: { page: 0, size: 50},

    };
  },

  watch: {
    'form.organization.contacts':{
        deep: true,
        handler: function(newContacts){
            for(const contact of newContacts){
                if(contact.isDirty){
                    this.updateContactOrganization(contact);
                    contact.isDirty = false;
                }
            }
        }
    }
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations(){
    return{
        form:{
            organization:{
                name:{
                    required
                },
                address:{
                    cep:{
                        required,
                    },
                    street:{
                        required,
                    },
                    number:{
                        required,
                    },
                    district:{
                        required,
                    },
                    city:{
                        required,
                    },
                    state:{
                        required,
                    },
                    country:{
                        required,
                    },
                },
                contacts:{
                    $each: helpers.forEach({

                        typeContact:{
                            required,
                        },

                        name:{
                            required,
                        },
                        email:{
                            required,
                            email,
                        },
                        phone:{
                            required,
                        },
                    })
                }

            }
        }
    }
  },

  computed: {
    ...mapGetters({
        storeOrg: 'orgs/getOrganization',
    }),
  },

  methods: {
    getOrganizationById(){
        orgService.getOrganizationById(this.organizationId).then(() => {
            this.form.organization = this.storeOrg;
        });
    },

    addNewContact(){
        this.form.organization.contacts.push(this.newContact);
        this.newContact = {
            id: '',
            name: '',
            email: '',
            phone: '',
            typeContact: '',
            isDirty: false
        }
    },
    
    addContactOrganization(contact: any): void{
        orgService.addContactOrganization(this.organizationId, contact)
    },

    updateContactOrganization(contact: any){
            orgService.updateContactOrganization(this.organizationId, contact.id, contact)
    },

    deleteContact(index: number){
        this.form.organization.contacts.splice(index, 1);
    },

    deleteContactOrganization(contactId: string){
        orgService.deleteContactOrganization(this.organizationId, contactId).then(() =>{
            this.$toast.add(ToastFactory.success(this.$t('toast.sucessContactDelete')));
            this.getOrganizationById();
        }).catch((e) => {
            console.log("erro", e)
            this.$toast.add(ToastFactory.error(this.$t('toast.errorContactDelete')));    
        })
    },

    mapContacts(): void{
        this.form.organization.contacts.forEach((contact: any) =>{
            contact.phone = contact.phone.replace(/\D/g, '');

            !contact.id ? this.addContactOrganization(contact) : contact.isDirty = true;
        })
    },

    addNewOrganization(data: OrganizationInterface): void {
        orgService.addOrganization(data)
        .then(() => {
            this.$router.push({ name: 'Organizations' });
            this.$toast.add(ToastFactory.success(this.$t('toast.sucessOrg')));
            }).catch((e) => {
            console.log("erro", e)
            this.$toast.add(ToastFactory.error(this.$t('toast.errorOrg')));    
        })
    },

    updateOrganization(data: OrganizationInterface): void {
        this.mapContacts();
       orgService.updateOrganization(this.organizationId, data)
       .then(() => {
            this.$router.go(-1);
            this.$toast.add(ToastFactory.success(this.$t('toast.sucessOrgEdit')));
         }).catch((e) => {
            console.log("erro", e)
            this.$toast.add(ToastFactory.error(this.$t('toast.errorOrgEdit')));    
        })
    },

    async getAddressData(): Promise<void>{
        const cep = this.form.organization.address.cep;
        orgService.getAdressData(cep).then((res) => {
            this.form.organization.address.street = res.logradouro;
            this.form.organization.address.district = res.bairro;
            this.form.organization.address.city = res.localidade;
            this.form.organization.address.state = res.uf;
        }).catch((e) => {
            console.log("erro", e)
            this.$toast.add(ToastFactory.error(this.$t('toast.errorAddressFind')));    
        })
    },

    sendOrganization(): void{
        this.v$.form.$touch();
        
        if(!this.v$.form.$invalid){
            this.organizationId ? 
                this.updateOrganization(this.form.organization) :
                 this.addNewOrganization(this.form.organization);
        }
    },
  },

  mounted() {
    this.organizationId = this.$route?.params?.id as string;
    this.organizationId ? this.getOrganizationById() : undefined;
  },

});
 